import { http, type Page } from '@shared/api';
import type { NotificationView, UnreadCount } from '../model/types';

export const notificationApi = {
  list: (page = 0, size = 20) =>
    http
      .get('notifications', { searchParams: { page: String(page), size: String(size) } })
      .json<Page<NotificationView>>(),

  markRead: (id: string) => http.post(`notifications/${id}/read`).json<void>(),

  // §13.2 — single round-trip mass mark-read (v1.1).
  markAllRead: () =>
    http.post('notifications/read-all').json<{ updated: number }>(),

  unreadCount: () => http.get('notifications/unread-count').json<UnreadCount>(),
};
